import { Box, Button, Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import CloseIcon from 'mdi-react/CloseIcon';
import moment from 'moment';
import { array, bool, func, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const WorkingHours = ({ shifts, day, onChange, loading = false }) => {
  const getTimeStr = seconds => moment.unix(seconds).utc().format('HH:mm');

  const removeShift = idx => () => {
    const newValue = [...shifts];
    newValue.splice(idx, 1);
    onChange(newValue);
  };

  const addShift = () => {
    const newValue = [...shifts];
    newValue.push({ from: 32400, to: 61200 });
    onChange(newValue);
  };

  const handleTimeChange = (which, idx, event) => {
    const [hours, minutes] = event.target.value.split(':');
    const value = hours * 3600 + minutes * 60;
    const newValue = shifts.map((shift, shiftIdx) =>
      shiftIdx === idx ? { ...shift, [which]: value } : shift,
    );
    onChange(newValue);
  };

  const textFieldSx = { verticalAlign: 'baseline' };
  const textFieldLoadingSx = {
    verticalAlign: 'baseline',
    '& input': {
      color: 'transparent',
    },
  };

  return (
    <Grid container sx={{ flex: '1 0 auto', mb: '25px', alignItems: 'baseline' }}>
      <Grid
        size={2}
        sx={{
          verticalAlign: 'baseline',
          height: '22px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSize: '15px',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontStretch: 'normal',
          letterSpacing: '-0.5px',
          lineHeight: 1.47,
          mr: '20px',
          textTransform: 'capitalize',
        }}
      >
        {day}
      </Grid>
      <Grid>
        <Box sx={{ mb: '5px' }}>
          {shifts.map &&
            shifts.map(({ from, to }, idx) => (
              <Box key={loading.toString() + idx} sx={{ verticalAlign: 'baseline', mb: '5px' }}>
                <TextField
                  type="time"
                  defaultValue={getTimeStr(from)}
                  sx={loading ? textFieldLoadingSx : textFieldSx}
                  onChange={event => handleTimeChange('from', idx, event)}
                  slotProps={{
                    htmlInput: {
                      step: 60, // 1 min
                    },
                  }}
                  disabled={loading}
                />
                <Box component="span" sx={{ verticalAlign: 'baseline', px: '10px' }}>
                  -
                </Box>
                <TextField
                  type="time"
                  value={getTimeStr(to)}
                  sx={loading ? textFieldLoadingSx : textFieldSx}
                  onChange={event => handleTimeChange('to', idx, event)}
                  slotProps={{
                    htmlInput: {
                      step: 60, // 1 min
                    },
                  }}
                  disabled={loading}
                />
                <Button onClick={removeShift(idx)}>
                  <CloseIcon style={{ width: 15 }} />
                </Button>
              </Box>
            ))}
        </Box>
        <Button sx={{ minHeight: 0, p: 0 }} onClick={addShift}>
          <Typography sx={{ color: 'primary.main' }} variant="caption">
            {I18n.t('EmployeeDrawer.Add shift')}
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

WorkingHours.propTypes = {
  shifts: array.isRequired,
  day: string.isRequired,
  onChange: func.isRequired,
  loading: bool,
};

export default WorkingHours;
